module.exports = __webpack_public_path__ + "cc69aa4918369e82743cd3ef4d6b84f1.svg";